<template>
  <div class="container-sm mt-20">
    <div class="w-full text-white p-4  text-center">
    <p>
      嗨 ,建築家人,歡迎你千里迢迢來到這隱蔽的地方，這裡要蒐集1000位建築人的匿名自我內心反省，在這裡我們不去檢討別人，就是內觀自己的內心。<br/>
      當達到1000位留言時，也是這個網站死亡的時候。當把1000位建築人的反省匯聚起來，會發生什麼事?會形成一種能量吧。我們可以去想像，你的內觀會渲染著別人
      ，甚至我們每年就拿去建築系畢設做展出。
    </p>
  </div>
    <div class="mx-4 h-full">
      <div class="message my-4 w-full " v-for="{ id, userName, text, likes, userId } in updatedMessages" :key="id">
        <span v-if="userId !== user?.uid">匿名 {{ userNameHandler(userName) }}</span>
        <div class="flex items-center h-full" :class="userId === user?.uid ? 'flex-row-reverse' : ''">
          <!-- <Avatar class="opacity-5" :src="userPhotoURL" /> -->
          <div class="w-full h-full text w-3/4 text-xl overflow-auto"
            :class="userId === user?.uid ? 'bg-gray-100 text-black' : 'bg-gray-700 text-white'">
            {{ text }}
          </div>
          <div v-if="userId === user?.uid">
            <p class="text-white whitespace-nowrap" @click="removeMessage(id)">刪除</p>
          </div>
          <div v-if="isLogin">
            <div v-if="userId !== user?.uid" class="w-12 flex items-center justify-start">
              <img class="w-4 mr-1 cursor-pointer"
                :src="require(`../../assets/img/${likes === 0 ? 'noheart.png' : 'heart.png'}`)"
                @click.once="addLikeToMessage(id)" alt="">
              <p class="text-white">{{ likes }}</p>
            </div>
          </div>
          <div v-else class="w-12 flex items-center justify-start">
            <img v-if="!likes" class="w-4 mr-1" src="../../assets/img/noheart.png" alt="">
            <img v-else class="w-4 mr-1 " src="../../assets/img/heart.png" alt="">
            <p class="text-white">{{ likes }}</p>
          </div>
          <div v-if="userId === user?.uid" class="w-12 mr-2 flex items-center justify-start">
            <img v-if="!likes" class="w-4 mr-1" src="../../assets/img/noheart.png" alt="">
            <img v-else class="w-4 mr-1" src="../../assets/img/yellowHeart.png" alt="">
            <p class="text-white">{{ likes }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div ref="bottom" class="mt-20" />
  <!--  -->
  <div class="bottom relative">
    <div class="container-sm">
      <form v-if="isLogin" @submit.prevent="send">
        <input v-model="message" placeholder="我的匿名告解訊息" required @enter.up="send" />
        <button type="submit">
          <img src="../../assets/img/handYellow.png" class="ml-2 w-14 hover:opacity-80" alt="">
        </button>
      </form> 
      <div v-else class="py-3 w-full text-yellow-300 text-center  flex-col">
        <a class="block" href="https://youtu.be/VDohzokMN4I" target="_blank">操作參考:建築之神我要告解使用說明影片</a>
        <a class=" text-gray-200 mt-1 text-sm block lg:absolute lg:right-10 lg:top-4"
          href="https://mail.google.com/mail/?view=cm&fs=1&to=funsugar8119@gmail.com&body=詢問建築留言板:" target="_blank">
          網站問題反映
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import Avatar from './Avatar.vue'
import { ref, computed } from 'vue'
import { useAuth, useChat } from '@/firebase'

export default {
  // components: { Avatar },
  setup() {
    const { user, isLogin } = useAuth()
    const { messages, sendMessage, removeMessage, addLike } = useChat()
    const updatedMessages = computed(() =>
      messages.value.map((message) => {
        const userLikes = Array.isArray(message.userLikes) ? message.userLikes : []
        const userLike = userLikes.find((like) => like.userId === user?.uid)
        const addedLike = userLike ? true : false
        return {
          ...message,
          addedLike
        }
      })
    )

    const userNameHandler = (name) => {
      name = name.split("")
      return name[0]
    }

    const message = ref('')

    const send = async () => {
      await sendMessage(message.value)
      message.value = ''
    }

    const addLikeToMessage = async (id) => {
      const message = updatedMessages.value.find((msg) => msg.id === id)
      if (message) {
        const updatedLikes = message.likes + 1
        await addLike(id, updatedLikes)
      }
    }

    return {
      user, isLogin,
      messages, sendMessage, removeMessage, addLike,
      updatedMessages, userNameHandler,
      message, send,
      addLikeToMessage
    }
  }
}
</script>
